<template>
  <div class="carrier-list-data">
    <div class="up-date-at" v-if="$_.get(freeList, 'data.length')>0">{{$updatedAtTime('数据更新时间')}}</div>
    <div class="result-data-banner align">
      <div class="index">序号</div>
      <div class="anchor-info">达人</div>
      <div class="level align jus">昨日直播收入</div>
    </div>
    <router-link :to="`/anchor/${$_.get(item, 'anchor.id')}`" v-for="(item, index) in freeList.data" :key="item.anchorId" class="item-default">
      <div class="commodity-sort">{{index+1}}</div>
      <div class="item-icon icon-radius">
        <img :src="$_.get(item, 'anchor.avatar')" alt="">
      </div>
      <div class="center-anchor-goods">
        <div class="item-name">{{$_.get(item, 'anchor.name')}}</div>
        <div class="item-fans">{{$retainWan($_.get(item, 'anchor.fans'))}}粉丝</div>
        <div class="item-tag-contain" v-if="$_.get(item, 'anchor.eCommerceTag').length>0">
          <div class="default-tag" v-for="(tag, index) in $_.get(item, 'anchor.eCommerceTag')" :key="index">{{tag}}</div>
        </div>
      </div>
      <div class="data-for-detail">
        <div class="data-title">礼物收入</div>
        <div class="data-number">¥{{$kuaibiCoin($_.get(item, 'receiveGift'))}}</div>
        <div class="data-title data-title-sec">销售总额</div>
        <div class="data-number">¥{{$retainWan($_.get(item, 'sales'))}}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        freeList: {}
      }
    },
    mounted () {
      this.query();
      this.$showLoading()
    },
    methods: {
      query() {
        let data = {
          road: 'gifshow'
        }
        this.$get({
          road: 'freeAnchor', 
          data, 
          params:{
            page: 50,
            index: 1,
            sort: 'fans',
            order: 'desc',
            eCommerceTagTake: 3
          }, 
          version:'v2'
        })
        .then(res=>{
          this.$toast.clear()
          this.freeList = res
        })
      },
      returnPosition(val) {
        return `background-position: ${this.$_.get(this.$store.state.sourceIconPosition[val.sourceType], 'position')}rem 0`
      }
    },
  }
</script>

<style lang="less" scoped>
  .result-data-banner {
    height: 0.6rem;
    line-height: 0.6rem;
    color: #A1AEBF;
    font-size: .2rem;
    width: 7.5rem;
    padding: 0 .3rem;
    background: #fff;
    margin-bottom: 0.1rem;
    .index {
      width: 1.7rem;
    }
    .anchor-info {
      flex: 1;
    }
  }
</style>